  <ng-select [items]="projects"
  bindLabel="url"
  bindValue="id"
  placeholder="Select project"
  [ngModel]="selectedId"
  [clearable]="false"
  (change)="onChange($event)"
  >
</ng-select>
